const filterFormSelector = '[data-type="filter"]';
$('body').on('submit', filterFormSelector, function (e) {
    $(this).find("input,select").each(function () {
        if ($(this).val() == '') {
            $(this).attr("name", "").attr("disabled", "disabled");
        }
    });
})